module.exports = __webpack_public_path__ + "media/promotional.3bb2176b.mp4";